import axios from 'axios';
import React, { useEffect, useState } from 'react';
import OptimizationTable from '../common/Table/OptimizationTable';
import { ReportContext } from "../../layout/Content/MainContent.component";
import Button from '@material-ui/core/Button';
import { useSnackbar } from "notistack";
import useOptimizationStyles from "./optimization.style"
import { get_content_types, get_mediums, get_metrics, submit_optimization_report, get_contenttype_mediums } from "../../config/apiUrls"
function Optimization() {
    const [mediums, setMediums] = useState([])
    const [metrics, setMetrics] = useState([])
    const [contentTypes, setContentTypes] = useState([]);
    const [contentTypeMedium, setContentTypeMedium] = useState([]);
    const [loading, setLoading] = useState(true);
    const {
        activeTab,
        handleNext,
        handlePrev,
        networks,
        year,
        week,
        reportType,
        setReportType,
        spec,
        temp,
        userInfo
    } = React.useContext(ReportContext);
    const classes = useOptimizationStyles()
    const { enqueueSnackbar } = useSnackbar();
    useEffect(() => {
        const getMediums = axios.get(get_mediums);
        const getMetrics = axios.get(get_metrics);
        const getContentTypes = axios.get(get_content_types);
        const getContentTypeMedium = axios.get(get_contenttype_mediums);
        axios.all([getMediums, getMetrics, getContentTypes, getContentTypeMedium]).then(axios.spread((...responses) => {
            setMediums(responses[0].data);
            setMetrics(responses[1].data);
            setContentTypes(responses[2].data);
            setContentTypeMedium(responses[3].data)
            setLoading(false);
        })).catch(error => {
            console.log(error);
            setLoading(false);
        })

    }, [])

    const handleSubmit = _ => {
        let zeroMaxThreshold = false
        spec.mediums.forEach(medium => {
            if (medium.maxThreshold === 0)
                zeroMaxThreshold = true

        })
        if (zeroMaxThreshold) {
            enqueueSnackbar("Max Threshold should be more than 0", {
                variant: 'error',
                autoHideDuration: 1500
            })
        }
        else {
            let payload = {
                year: spec.year,
                // dates:spec.dates,            
                reportType: spec.reportType,
                reportName: spec.reportName,
                weekId: spec.weekId,
                userId: userInfo.email,
                statusId: 1,
                networkDisplayName: spec.networkDisplayName,
                input: JSON.stringify(spec)
            }
            axios.post(submit_optimization_report, payload).then(responses => {
                if (responses.data) {
                    enqueueSnackbar("Report submitted sucessfully", {
                        variant: 'success',
                        autoHideDuration: 1500
                    })
                    handleNext(activeTab)
                }
                else {
                    enqueueSnackbar("Unable to submit the report.", {
                        variant: 'error',
                        autoHideDuration: 1500
                    })
                    handleNext(activeTab)
                }

            })
        }
    }

    return (
        <>
            <div style={{ position: "absolute", right: "8vw", fontSize: "0.85rem" }}>
                - Spend represents $(000s)<br />
                - Impressions represents (000s)
        </div>
            <div style={{ display: "table", margin: "auto", marginTop: 30 }}>
                <OptimizationTable loading={loading} data={mediums} contentTypes={contentTypes} contentTypeMedium={contentTypeMedium} metrics={metrics} />
                <div style={{ display: "flex", justifyContent: "flex-end", margin: "10px auto" }}>
                    <Button variant="outlined" classes={{ root: classes.button, label: classes.buttonLabel }} onClick={e => handlePrev(activeTab)}>Back</Button>
                    <Button disabled={temp["selectedMediums"] === undefined || temp["selectedMediums"].length === 0} variant="contained" color="primary" classes={{ root: classes.button, label: classes.buttonLabel }} onClick={handleSubmit}>Submit</Button>
                </div>
            </div>
        </>
    );
}

export default Optimization;
